import React, { useState } from "react";
import SelectDropdown from "../common/SelectDropdown";
import { filterSvg } from "../common/svgs";

const StatusDropdown = ({
  statusFilter,
  setStatusFilter,
  options,
  disable = false,
}) => {
  const handleChange = (option) => {
    setStatusFilter(option);
  };
  return (
      <div className="w-48">
        <SelectDropdown onChange={handleChange} selectedOption={statusFilter} options={options}
          icon={filterSvg("10px", "15px", "black")}
          containerStyles="px-4 py-[10px] rounded-lg border-[1px] border-gray-border w-48 bg-white-default "
          dropdownClassName="border-[#F2F4F7] border-[1px] rounded-lg w-48 p-4"
        />
      </div> 
  );
};

export default StatusDropdown;
